import { useReactiveVar } from "@apollo/client";

import { makeFSVar } from "@shared/reactiveVar/makeFSVar";

const shouldFrontendRefreshVar = makeFSVar(false, "shouldFrontendRefreshVar");

const resetShouldFrontendRefresh = () => shouldFrontendRefreshVar(false);

const updateShouldFrontendRefresh = (newValue: boolean) => {
  shouldFrontendRefreshVar(newValue);
};

const useShouldFrontendRefresh = () => useReactiveVar(shouldFrontendRefreshVar);

export { resetShouldFrontendRefresh, updateShouldFrontendRefresh, useShouldFrontendRefresh };
